import { ThunkAction } from 'components/redux/types/ThunkAction';
import { MenuMainLoadResponseType } from 'moduleBase/modules/menu/actions/types/MenuMainLoadResponseType';
import { APP_LOAD_MENU_MAIN_SUCCESS, APP_LOAD_MENU_MAIN_URL } from 'moduleBase/modules/menu/constants';

const menuMainLoadSuccess = (menu) => ({
  type: APP_LOAD_MENU_MAIN_SUCCESS,
  payload: {
    menu,
  },
});

const menuMainLoad = (): ThunkAction => (dispatch, getState, { networkService }) => {
  networkService.get<MenuMainLoadResponseType>(APP_LOAD_MENU_MAIN_URL).then((response) => {
    dispatch(menuMainLoadSuccess(response.data.menu));
  });
};

export { menuMainLoad };
